import { render } from "./QualityAssurance.vue?vue&type=template&id=4bd324a6"
import script from "./QualityAssurance.vue?vue&type=script&lang=js"
export * from "./QualityAssurance.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__